import React from 'react';

interface BrandLogoProps {
  className?: string;
  alt?: string;
}

/** BuildMate project mark — used in header, auth, and marketing nav. */
const BrandLogo: React.FC<BrandLogoProps> = ({
  className = 'h-6 w-6',
  alt = 'BuildMate',
}) => (
  <img
    src={`${process.env.PUBLIC_URL || ''}/logo128.png`}
    alt={alt}
    className={`shrink-0 object-contain ${className}`}
    draggable={false}
  />
);

export default BrandLogo;
